import { render } from "./PhoneField.vue?vue&type=template&id=ca1c32a4&scoped=true"
import script from "./PhoneField.vue?vue&type=script&lang=js"
export * from "./PhoneField.vue?vue&type=script&lang=js"

import "./PhoneField.vue?vue&type=style&index=0&id=ca1c32a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ca1c32a4"

export default script